import { render, staticRenderFns } from "./ShopSettingsTab.vue?vue&type=template&id=780669da&"
import script from "./ShopSettingsTab.vue?vue&type=script&lang=js&"
export * from "./ShopSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports